import { css } from "../helpers/webComponents";
import { IntroComponent } from "./IntroComponent";

/**
 * Represents the intro screen.
 */
export class EndingComponent extends IntroComponent {
    /**
     * @inheritdoc
     */
    protected styles(): string {
        return super.styles() + css`
            .main {
                flex-direction: column;
                align-items: flex-start;
                gap: 10px;
            }

            .footer {
                margin: 0;
            }

            .footer .button {
                background-color: rgb(121 0 0 / 70%);
            }

            .footer .button:hover {
                background-color: rgb(200 0 0 / 90%);
            }
        `;
    }
};
